import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/share/share_icom_location@2x.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-67eeb815")

_pushScopeId("data-v-67eeb815")
const _hoisted_1 = {
  class: "home",
  id: "home"
}
const _hoisted_2 = { class: "head" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "icon" }, null, -1)
const _hoisted_4 = { class: "headimg" }
const _hoisted_5 = { class: "pic" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "headicon1" }, null, -1)
const _hoisted_7 = { class: "name" }
const _hoisted_8 = {
  class: "share_btn_save",
  id: "save"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("canvas", {
    id: "head_canvas",
    style: {"display":"none"}
  })
], -1)
const _hoisted_10 = { class: "share_message_1" }
const _hoisted_11 = /*#__PURE__*/_createVNode("pre", null, "我在", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_13 = { style: {"color":"#E83C41","font-weight":"bolder","margin-right":"1vw"} }
const _hoisted_14 = /*#__PURE__*/_createVNode("pre", null, "为大国工程助力", -1)
const _hoisted_15 = { class: "share_message_2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "share_message_3" }, null, -1)
const _hoisted_17 = { class: "button" }
const _hoisted_18 = {
  id: "poster",
  class: "poster",
  style: {"display":"none"}
}
const _hoisted_19 = {
  class: "Canvas",
  style: {"display":"none"}
}
const _hoisted_20 = /*#__PURE__*/_createVNode("canvas", {
  id: "myCanvas",
  style: {"display":"none"}
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "up" }, "上拉赢积分大奖", -1)
const _hoisted_22 = {
  class: "foot2",
  id: "foot2"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_24 = { class: "footer1" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("您本轮专属大奖抽奖码 : ")
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"1.05vh","color":"white"} }, "(抽奖码每轮更新，请先复制抽奖码后，点击参与抽奖按钮)", -1)
const _hoisted_27 = { class: "footer3" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("您的当前积分 : ")
const _hoisted_29 = { style: {"color":"#FEDE2F","font-weight":"bold"} }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 分，优胜者可获万元大奖! ")
const _hoisted_31 = { class: "footer5" }
const _hoisted_32 = { style: {} }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 详情请查看")
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = { style: {"padding-top":"2%","float":"right","color":"white"} }
const _hoisted_36 = { style: {"color":"#FEDE2F","float":"inherit"} }
const _hoisted_37 = {
  class: "delayfooter",
  id: "delayfooter",
  style: {"overflow":"hidden","display":"none"}
}
const _hoisted_38 = { style: {"margin-top":"16vh"} }
const _hoisted_39 = { class: "footer3" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("您的当前积分 : ")
const _hoisted_41 = { style: {"color":"#FEDE2F","font-weight":"bold"} }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" 分，优胜者可获万元大奖! ")
const _hoisted_43 = { class: "footer5" }
const _hoisted_44 = { style: {} }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 详情请查看")
const _hoisted_46 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_47 = { style: {"padding-top":"2%","float":"right","color":"white"} }
const _hoisted_48 = { style: {"color":"#FEDE2F","float":"inherit"} }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", {
  id: "dream",
  class: "dream",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createVNode("canvas", {
    id: "animation_canvas",
    style: {}
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_diV = _resolveComponent("diV")
  const _component_invite_poster = _resolveComponent("invite-poster")
  const _component_marquee = _resolveComponent("marquee")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_diV, { class: "headicon" }),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("img", {
            src: _ctx.codeImg,
            style: {"pointer-events":"none"}
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.name), 1),
          _createVNode("div", _hoisted_8, [
            _createVNode("p", null, _toDisplayString(_ctx.save), 1)
          ])
        ]),
        _hoisted_9
      ])
    ]),
    _createVNode("div", {
      class: "jian20",
      onTouchend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.end && _ctx.end(...args))),
      onTouchstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.move && _ctx.move(...args))),
      style: {'backgroundImage':'url('+_ctx.imgurl[_ctx.imgIndex].style+')'}
    }, null, 36),
    _createVNode("div", {
      class: "share_message",
      onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.end && _ctx.end(...args))),
      onTouchstart: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.move && _ctx.move(...args)))
    }, [
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _hoisted_12,
        _createVNode("pre", _hoisted_13, _toDisplayString(_ctx.city), 1),
        _hoisted_14
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode("pre", null, _toDisplayString(_ctx.province) + "已有" + _toDisplayString(_ctx.persnum) + "人参与挑战", 1)
      ]),
      _hoisted_16
    ], 32),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", {
        class: "button1",
        onTouchend: _cache[5] || (_cache[5] = ($event: any) => (_ctx.gotoLink("/")))
      }, null, 32),
      _createVNode("div", {
        class: "button2",
        onTouchend: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showExtension()))
      }, null, 32)
    ]),
    _createVNode("div", {
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hidePosters && _ctx.hidePosters(...args))),
      class: {hidePoster:_ctx.showPoster}
    }, null, 2),
    _withDirectives(_createVNode(_component_invite_poster, { onHideposter: _ctx.hidePosters }, null, 8, ["onHideposter"]), [
      [_vShow, _ctx.showPoster]
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode("img", {
          src: _ctx.dataURL,
          alt: "",
          class: "modalImg"
        }, null, 8, ["src"])
      ])
    ]),
    _createVNode("div", {
      class: "foot",
      id: "foot",
      style: {},
      onTouchend: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.end && _ctx.end(...args))),
      onTouchstart: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.move && _ctx.move(...args)))
    }, [
      _createVNode("div", {
        class: "foot3",
        onTouchend: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.changefoot && _ctx.changefoot(...args)))
      }, null, 32),
      _hoisted_21,
      _createVNode("div", _hoisted_22, "您本轮专属大奖抽奖码：" + _toDisplayString(_ctx.code), 1),
      _hoisted_23
    ], 32),
    _createVNode("div", {
      class: "footer",
      id: "footer",
      style: {"display":"none","overflow":"hidden"},
      onTouchend: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.end && _ctx.end(...args))),
      onTouchstart: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.move && _ctx.move(...args)))
    }, [
      _createVNode("div", null, [
        _createVNode("div", {
          class: "down",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changefooter()))
        }),
        _createVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode("a", {
            id: "code",
            style: {"color":"#FEDE2F","text-decoration":"underline","font-weight":"bold"},
            onTouchend: _cache[12] || (_cache[12] = ($event: any) => (_ctx.copy()))
          }, _toDisplayString(_ctx.code), 33)
        ]),
        _createVNode("div", {
          class: "footer2",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.gotoLink("/lottery?code="+_ctx.code)))
        }),
        _hoisted_26
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode("a", _hoisted_29, _toDisplayString(_ctx.score), 1),
          _hoisted_30
        ]),
        _createVNode("div", {
          class: "footer4",
          onTouchend: _cache[14] || (_cache[14] = ($event: any) => (_ctx.gotoLink("/test")))
        }, null, 32),
        _createVNode("div", _hoisted_31, [
          _createVNode("p", _hoisted_32, [
            _hoisted_33,
            _hoisted_34,
            _createVNode("a", {
              style: {},
              onTouchend: _cache[15] || (_cache[15] = ($event: any) => (_ctx.gotoLink("/rule")))
            }, "活动规则>>", 32)
          ])
        ])
      ]),
      _createVNode(_component_marquee, {
        class: "marquee",
        scrollamount: "4",
        width: "100%",
        height: "10%",
        direction: "left",
        Align: "Middle"
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.polluser, (item, index) => {
            return (_openBlock(), _createBlock("li", {
              style: {"display":"inline-block","margin-left":"10vw"},
              key: index
            }, [
              _createVNode("img", {
                style: {"border-radius":"50%","border":"2px solid rgba(255, 255, 255, 0.7)","width":"30px","color":"rgba(255, 255, 255, 0.7)","text-align":"center","line-height":"28px","height":"30px"},
                src: item.avatar
              }, null, 8, ["src"]),
              _createVNode("p", _hoisted_35, [
                _createTextVNode("恭喜" + _toDisplayString(item.name) + "获得 ", 1),
                _createVNode("a", _hoisted_36, _toDisplayString(item.prize), 1)
              ])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ], 32),
    _createVNode("div", _hoisted_37, [
      _createVNode("div", {
        class: "dalaydown",
        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.changedelayfooter()))
      }),
      _createVNode("div", _hoisted_38, [
        _createVNode("div", _hoisted_39, [
          _hoisted_40,
          _createVNode("a", _hoisted_41, _toDisplayString(_ctx.score), 1),
          _hoisted_42
        ]),
        _createVNode("div", {
          class: "footer4",
          onTouchend: _cache[19] || (_cache[19] = ($event: any) => (_ctx.gotoLink("/test")))
        }, null, 32),
        _createVNode("div", _hoisted_43, [
          _createVNode("p", _hoisted_44, [
            _hoisted_45,
            _hoisted_46,
            _createVNode("a", {
              style: {},
              onTouchend: _cache[20] || (_cache[20] = ($event: any) => (_ctx.gotoLink("/rule")))
            }, "活动规则>>", 32)
          ])
        ])
      ]),
      _createVNode(_component_marquee, {
        class: "marquee2",
        scrollamount: "4",
        width: "100%",
        height: "10%",
        direction: "left",
        Align: "Middle"
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.polluser, (item, index) => {
            return (_openBlock(), _createBlock("li", {
              style: {"display":"inline-block","margin-left":"10vw"},
              key: index
            }, [
              _createVNode("img", {
                style: {"border-radius":"50%","border":"2px solid rgba(255, 255, 255, 0.7)","width":"30px","color":"rgba(255, 255, 255, 0.7)","text-align":"center","line-height":"28px","height":"30px"},
                src: item.avatar
              }, null, 8, ["src"]),
              _createVNode("p", _hoisted_47, [
                _createTextVNode("恭喜" + _toDisplayString(item.name) + "获得 ", 1),
                _createVNode("a", _hoisted_48, _toDisplayString(item.prize), 1)
              ])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _hoisted_49
  ]))
})